// extracted by mini-css-extract-plugin
export var founderImage = "OurStory-module--founderImage---1LRK";
export var founderInfo = "OurStory-module--founderInfo--ql0ni";
export var founderName = "OurStory-module--founderName--0oNZb";
export var founderTitle = "OurStory-module--founderTitle--VLnWf";
export var imageColumn = "OurStory-module--imageColumn--Pnnll";
export var imageContainer = "OurStory-module--imageContainer--uMY-w";
export var jahangirSection = "OurStory-module--jahangirSection--MYc2H";
export var malukSection = "OurStory-module--malukSection--fY+vt";
export var ourStoryImage = "OurStory-module--ourStoryImage--e4aG-";
export var ourStoryImageContainerDesktop = "OurStory-module--ourStoryImageContainerDesktop--OJ3Gm";
export var ourStoryImageContainerMobile = "OurStory-module--ourStoryImageContainerMobile--6gvHk";
export var ourStoryImageDesktop = "OurStory-module--ourStoryImageDesktop--yAvdx";
export var ourStoryImageMobile = "OurStory-module--ourStoryImageMobile--rMNzW";
export var ourStoryWrapper = "OurStory-module--ourStoryWrapper--g9Chf";
export var storyContent = "OurStory-module--storyContent--OMN98";
export var storyParagraph = "OurStory-module--storyParagraph--cfx1r";
export var storySection = "OurStory-module--storySection--WOXjM";
export var textColumn = "OurStory-module--textColumn--0QbPM";